import React from 'react';
import { EmployeeRequestForm } from './EmployeeRequestForm';
import { ManagerRequestForm } from './ManagerRequestForm';
import { RequestFormMode, RequestFormProps } from './RequestForm/types';

type Props = {
  mode: RequestFormMode;
} & RequestFormProps;

export const RequestForm: React.FC<Props> = ({ mode, ...restProps }) => {
  if (mode === 'employee') {
    return <EmployeeRequestForm {...restProps} />;
  }
  return <ManagerRequestForm {...restProps} />;
};
